<template>
    <section class="d-flex flex-column h-full">
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>
        <div class="flex-grow-1 scroll-y">
            <router-view></router-view>
        </div>
    </section>
</template>

<script>
/**
 * 구매하기 메인 컴포넌트(sales main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'

export default {
    name: 'sales',
    data() {
        return {
        }
    },
    components: {
        TopAppBar
    },

    mixins: [topAppBarMixin],
    mounted() {
    },
    methods: {
    }
}
</script>